import React, { useState, useRef, useEffect } from 'react';
import titleStyles from '../../screens/ForthScreen.module.css';
import styles from './ContentShowcase.module.css';

const LazyYoutubeEmbed = ({ videoId, index }) => {
  const ref = useRef(null);
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShowIframe(true);
        observer.disconnect();
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px) scale(0.95)';
      element.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              element.style.opacity = '1';
              element.style.transform = 'translateY(0) scale(1)';
            }, index * 100);
            observer.unobserve(element);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      observer.observe(element);
      return () => observer.disconnect();
    }
  }, [index]);

  return (
    <div className={styles.shortItem} ref={ref}>
      {showIframe && (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          title={`Short ${index + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.iframe}
          loading="lazy"
        />
      )}
    </div>
  );
};

const ContentShowcase = () => {
  const categories = [
    {
      title: "בתהליך של ניהול סושיאל של…",
      subcategories: [
        { name: "מיטל אברהמי מטפלת תודעתית מהשורש", videos: ["7wRooBTr2qY", "dANS5F2z4uQ"] },
        { name: "קסניה נוה יועצת שינה", videos: ["e4Ck_nP43Y4", "_RUVKRfL0d4"] },
        { name: "סטודיו מיילו לפילאטיס מכשירים", videos: ["nlIZjN2ft7s", "zCZAVa06snU"] },
        { name: "בורקס בכר העגלה אור עקיבא", videos: ["gB4JJMqyjiY", "74TCIzAt-fU"] }
      ]
    },
    {
      title: "ביום צילום של…",
      subcategories: [
        { name: "שלי מאיר באקדמיה לאיפור קבוע", videos: ["bRM66zoY4T8", "tkZa21HOOcQ"] }
      ]
    }
  ];

  let globalIndex = 0;

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        {/* Main title - site style */}
        <div className={titleStyles.title}>
          ואיך נראה תוכן מדוייק לקהל היעד שלכן -
          <div className={titleStyles.titleHighlight}>בדיוק ככה</div>
        </div>

        {categories.map((category, catIdx) => (
          <div key={catIdx} className={styles.categoryBlock}>
            {/* Category title - site style */}
            <div className={titleStyles.title} style={{ fontSize: '2rem' }}>
              {category.title}
            </div>

            {category.subcategories.map((sub, subIdx) => (
              <div key={subIdx} className={styles.subcategory}>
                {/* Subcategory name - description style */}
                <div className={titleStyles.description}>{sub.name}</div>
                <div className={styles.videosRow}>
                  {sub.videos.map((videoId) => {
                    const idx = globalIndex++;
                    return <LazyYoutubeEmbed key={videoId} videoId={videoId} index={idx} />;
                  })}
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* Instagram section */}
        <div className={titleStyles.description}>
          ולעוד קצת תוכן שלי ושל אחרים - תעקבו אחרי בעמוד האינסטגרם שלי
        </div>
        <div className={styles.instagramLinkWrapper}>
          <a
            href="https://www.instagram.com/natalie_social_shvartz/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.instagramLink}
          >
            @natalie_social_shvartz
          </a>
        </div>

        <div className={styles.whatsappBtnWrapper}>
          <a
            href="https://chat.whatsapp.com/BeFBfAiJQXkJtuKo78cVfr?mode=gi_t"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.whatsappBtn}
          >
            קישור לקבוצת ווטסאפ שלי
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;
